<template>
  <header-bar></header-bar>
  <main class="min-h-full lg:min-h-inherit">
    <router-view v-slot="{ Component }">
      <transition name="pageload" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </main>
  <footer-bar></footer-bar>
  <contact-modal v-show="modal"></contact-modal>
</template>
<script>
import { mapGetters } from 'vuex';

import HeaderBar from '@/components/header/Index.vue';
import FooterBar from '@/components/footer/Index.vue';
import ContactModal from '@/components/modal/ContactModal.vue';

export default {
  name: 'DefaultLayout',
  components: {
    HeaderBar,
    FooterBar,
    ContactModal,
  },
  computed: {
    ...mapGetters(['modal']),
  },
};
</script>
